module.exports = __webpack_public_path__ + "img/fingerprint-fourteen.eef6cecd.svg";